import {MAX_ALERTS_PER_ISSUE_ERROR_MESSAGE} from '@github-ui/item-picker-alert/CodeScanningAlertPicker'
import {useCallback, useState} from 'react'

export function useAlertTrackingErrors() {
  const [errors, setErrors] = useState<Array<{title: string; body: string}>>([])

  const resetErrors = useCallback(() => setErrors([]), [])

  const setFromNewErrors = useCallback((newErrors: Error[]) => {
    for (const error of newErrors) {
      if (error.message.includes(MAX_ALERTS_PER_ISSUE_ERROR_MESSAGE)) {
        setErrors(currentErrors => [
          ...currentErrors,
          {
            title: 'Error',
            body: error.message,
          },
        ])
        continue
      }

      setErrors(currentErrors => [
        ...currentErrors,
        {
          title: 'Unexpected error',
          body: `An unexpected error occurred. ${error.message}`,
        },
      ])
    }
  }, [])

  return {errors, resetErrors, setErrors: setFromNewErrors}
}
